export async function fetchRequest(endpoint: string, data?: Record<string, unknown>): Promise<Response> {
	const url = process.env.NEXT_PUBLIC_SITECORE_BASE_URL + endpoint;

	if (!data) {
		return await fetch(url, { credentials: 'include' });
	}

	const body = new URLSearchParams();

	Object.entries(data).forEach(([key, value]) => {
		const valueString = typeof value === 'string' ? value : JSON.stringify(value);
		return body.append(key, valueString);
	});

	const init: RequestInit = { method: 'POST', credentials: 'include', body };

	return await fetch(url, init);
}
